import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BOARD_STATUSES } from '@/features/rentals/board-filter';
import { RentalsPage } from '@/features/rentals/pages/rentals-page';
import { requireRentalShop } from '@/lib/rental-guard';

/** `?tab=list` is where the import and the pictures upload come back to; `?tab=refunds` is the security deposits to hand back; `?open=<appointment id>` (bell, legacy calendar links) highlights that rental on the board; with `&money=true` its sheet opens too (the counter tried to bill a rental on checkout). `?q=` (search words), `?cat=` (category id) and `?st=` (status chip) are the board's filter, kept in the address so back and refresh keep it. */
export const Route = createFileRoute('/_app/rentals')({
  beforeLoad: requireRentalShop,
  validateSearch: z.object({
    tab: z.enum(['board', 'list', 'items', 'refunds']).optional().catch(undefined),
    open: z.string().uuid().optional().catch(undefined),
    money: z.boolean().optional().catch(undefined),
    q: z.string().trim().max(80).optional().catch(undefined),
    cat: z.string().uuid().optional().catch(undefined),
    st: z.enum(BOARD_STATUSES).optional().catch(undefined),
  }),
  component: RentalsPage,
});
